<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="createClient">
      <b-form
        class="mt-2"
        @submit.prevent="handleSubmit"
        @keydown.enter="handleSubmit"
      >
        <b-row>
          <b-col cols="12">
            <h4 class="mb-2">Detalles cliente</h4>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              name="Nombre"
              rules="required"
            >
              <b-form-group label="Nombre" label-for="client-name">
                <b-form-input
                  v-model="name"
                  name="name"
                  placeholder="Nombre"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>

          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              name="CIF"
              rules="required"
            >
              <b-form-group label="CIF" label-for="client-cif">
                <b-form-input
                  v-model="cif"
                  name="reference"
                  placeholder="CIF"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              name="Dirección"
              rules="required"
            >
              <b-form-group label="Dirección" label-for="client-address">
                <b-form-input
                  v-model="address"
                  name="reference"
                  placeholder="Dirección"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              name="Código postal"
              rules="required"
            >
              <b-form-group
                label="Código postal"
                label-for="client-postalCode"
              >
                <b-form-input
                  v-model="postalCode"
                  name="reference"
                  placeholder="Código postal"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              name="Región"
              rules="required"
            >
              <b-form-group label="Región" label-for="client-region">
                <b-form-input
                  v-model="region"
                  name="reference"
                  placeholder="Región"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              name="País"
              rules="required"
            >
              <b-form-group label="País" label-for="client-country">
                <b-form-input
                  v-model="country"
                  name="reference"
                  placeholder="País"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              name="Ciudad"
              rules="required"
            >
              <b-form-group label="Ciudad" label-for="client-city">
                <b-form-input
                  v-model="city"
                  name="reference"
                  placeholder="Ciudad"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              name="Teléfono"
              rules="required"
            >
              <b-form-group label="Teléfono" label-for="client-phone">
                <b-form-input
                  v-model="phone"
                  name="reference"
                  placeholder="Teléfono"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              name="Email"
              rules="email|required"
            >
              <b-form-group label="Email" label-for="client-email">
                <b-form-input
                  v-model="emailInput"
                  name="reference"
                  placeholder="Email"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              name="Web"
              rules="required"
            >
              <b-form-group label="Web" label-for="client-web">
                <b-form-input
                  v-model="web"
                  name="reference"
                  placeholder="Web"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="12">
            <b-form-group label="Imagen" label-for="client-image">
              <ImageDropzone ref="image" :files="files" maxFiles="1" />
            </b-form-group>
          </b-col>
          <b-col cols="12 text-right">
            <b-button type="submit" variant="primary" class="mt-2 mr-1">
              Enviar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import Ripple from "vue-ripple-directive";
import ImageDropzone from "@/components/elements/ImageDropzone/ImageDropzone.vue";

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    ImageDropzone,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      name: "",
      cif: "",
      address: "",
      region: "",
      postalCode: "",
      city: "",
      emailInput: "",
      web: "",
      phone: "",
      country: "",
      files: [],
      required,
      email,
    };
  },
  computed: {
    ...mapGetters({
      client: "clients/getClient",
    }),
  },
  methods: {
    ...mapActions({
      create: "clients/create",
      getClient: "clients/getClient",
    }),
    handleSubmit() {
      this.$refs.createClient.validate().then((success) => {
        if (success) {
          const formData = this.createFormData();
          if (formData) {
            this.create({ client: formData });
          }
        }
      });
    },
    createFormData() {
      const data = this.$refs.image.getFormData("image");

      data.append("name", this.name);
      data.append("cif", this.cif);
      data.append("address", this.address);
      data.append("postalCode", this.postalCode);
      data.append("region", this.region);
      data.append("country", this.country);
      data.append("city", this.city);
      data.append("phone", this.phone);
      data.append("email", this.emailInput);
      data.append("web", this.web);

      return data;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
